__turbopack_context__.v({
  "className": "roboto_25ee5e6-module__V82N6q__className",
});
